<template>
  <group-form :group="newGroup" :type="type"></group-form>
</template>

<script>
import GroupForm from '../Group/groupForm'
import {Group} from '../../../object'

export default {
  name: 'NewGroup',
  components: {GroupForm},
  data: () => ({
    newGroup: new Group(),
    type: null
  })
}
</script>

<style scoped>

</style>
